export type PasskeyType = -1 | 1 | 2 // -1=不支持, 1=苹果, 2=谷歌

function detectEnv(nav: Navigator = navigator) {
  const anyNav = nav as any
  let {
    userAgentData: { brands = [], platform = '' },
    userAgent = '',
  } = anyNav
  platform = platform.toLowerCase()

  // 整合品牌信息，识别 Chromium 家族（Chrome/Edge/Opera/Brave 等）
  const brandStr = brands.map((b: any) => b.brand).join(' ')

  // 是否 Chromium 家族
  const isChromium =
    /Chrom(e|ium)|Google Chrome|Microsoft Edge|Opera|OPR|Brave/i.test(brandStr) ||
    /Chrome|Chromium|Edg|OPR|Brave/i.test(userAgent)

  // Safari 识别（排除 Chromium 标记）
  const isSafari =
    /Safari\//.test(userAgent) &&
    !/Chrome\//.test(userAgent) &&
    !/Chromium\//.test(userAgent) &&
    !/Edg\//.test(userAgent) &&
    !/OPR\//.test(userAgent)

  // 平台判断
  const isWindows = platform.includes('win') || /Windows NT/i.test(userAgent)
  const isMac = platform.includes('mac') || /Macintosh/i.test(userAgent)

  return { isWindows, isMac, isChromium, isSafari }
}

/**
 * 根据用户已绑定的 credential 类型 + 运行环境(平台/浏览器) 得出要验证的通行密钥类型
 * - 输入 boundTypes: [1] 表示仅绑定苹果；[2] 仅谷歌；[1,2] 都有；[] 未绑定
 * - 规则：
 *   Windows + Chromium：优先 2(谷歌)；若未绑谷歌但已绑苹果 → 1（允许“手机扫码”跨设备）
 *   macOS + Safari：1(苹果)；macOS + Chromium：优先 2，无则 1
 *   其它：-1
 */
export function decidePasskeyType(
  boundTypes: number[] | null,
  nav: Navigator = navigator,
): PasskeyType {
  if (boundTypes == null) return -1
  // 先判断绑定情况，空则 -1
  const hasApple = boundTypes?.includes(1)
  const hasGoogle = boundTypes?.includes(2)
  if (!hasApple && !hasGoogle) return -1

  const { isWindows, isMac, isChromium, isSafari } = detectEnv(nav)

  // Windows 规则：Chromium 且有谷歌 → 2；否则若已绑苹果 → 1（允许 iPhone 跨设备扫码）；余下 -1
  if (isWindows) {
    if (isChromium && hasGoogle) return 2
    if (hasApple) return 1 // 允许 hybrid（手机）在 Windows 上完成
    return -1
  }

  // macOS：Safari → 苹果；Chromium → 优先谷歌，无则苹果；否则 -1
  if (isMac) {
    if (isSafari) return hasApple ? 1 : -1
    if (isChromium) return hasGoogle ? 2 : hasApple ? 1 : -1
  }

  // 其它平台/浏览器：按你的要求一律不支持
  return -1
}
